export const USER_TERMS = {
  title: "Terms & Conditions",
  version: "1.0",
  effectiveDate: "2025-02-18",
  summary: [
    "By creating an account and using Sendrey, you agree to these terms.",
    "All payments are held in escrow until task completion or approval.",
    "You must review submissions and approve/dispute before escrow release.",
    "Ratings are permanent and can only be given after escrow release.",
    "Platform fees are non-refundable once task is approved."
  ],
  sections: [
    {
      title: "1. Acceptance of Terms",
      content: "By creating an account, funding a task, or using Sendrey services, you agree to these User Terms & Conditions. Acceptance is required once and applies to all subsequent use unless materially updated."
    },
    {
      title: "2. Platform Role",
      content: "Sendrey operates as a facilitation platform connecting users with independent runners. Sendrey is not a merchant, courier, or seller of goods."
    },
    {
      title: "3. Task Creation & Scope",
      content: "Users are responsible for accurately describing tasks, budgets, delivery requirements, and pickup details. Tasks are binding once funded."
    },
    {
      title: "4. Payments & Escrow",
      content: "All payments are processed in-chat and held in escrow prior to task execution.\n• Funds remain in escrow until user approval or dispute resolution.\n• For shopping tasks, item purchases are executed by the system using escrowed funds.\n• For pickup services, only delivery fees are escrowed."
    },
    {
      title: "5. Approval & Confirmation",
      content: "Users must review runner submissions and approve or dispute tasks before escrow release. Failure to act within defined timeframes may trigger automatic confirmation."
    },
    {
      title: "6. Fees",
      content: "Delivery fees include platform fees as disclosed at payment time. Fees are non-refundable once the task is approved."
    },
    {
      title: "7. Disputes",
      content: "Users may initiate disputes prior to escrow release. Disputes pause payment and are resolved through Sendrey's internal process. Decisions are final."
    },
    {
      title: "8. Ratings & Feedback",
      content: "Users may rate runners only after escrow release. Ratings are permanent and impact platform trust signals."
    },
    {
      title: "9. Prohibited Conduct",
      content: "Users may not:\n• Circumvent platform payments\n• Engage runners off-platform\n• Request illegal or unsafe activities"
    },
    {
      title: "10. Limitation of Liability",
      content: "Sendrey is not liable for indirect losses, vendor quality, or user-runner disputes beyond escrow handling."
    },
    {
      title: "11. Account Enforcement",
      content: "Sendrey may suspend or terminate accounts for violations."
    },
    {
      title: "12. Governing Law",
      content: "These terms are governed by applicable local law."
    }
  ]
};

export const RUNNER_TERMS = {
  title: "Runner Agreement",
  version: "1.0",
  effectiveDate: "2025-02-18",
  summary: [
    "You operate as an independent contractor, responsible for taxes and expenses.",
    "Accepted tasks are binding. Never use personal funds for purchases.",
    "Payouts are released only after user approval or system confirmation.",
    "Platform fees are deducted automatically from your earnings.",
    "Ratings impact your task access and account status.",
    "Sendrey uses your location to match you with nearby errands and keep users updated on your delivery in real time. For this reason, we require location access to remain active while you're online as a runner.",
  ],
  sections: [
    {
      title: "1. Acceptance",
      content: "By onboarding as a runner, you agree to this Runner Agreement."
    },
    {
      title: "2. Independent Contractor Status",
      content: "Runners operate as independent contractors and are responsible for their own taxes, expenses, and compliance."
    },
    {
      title: "3. Task Acceptance",
      content: "Accepted tasks are binding. Runners must follow task instructions and budgets."
    },
    {
      title: "4. No Personal Funding",
      content: "Runners must never use personal funds to purchase items or request off-platform payments."
    },
    {
      title: "5. Task Execution",
      content: "Runners must submit required proof before completion. Approval is required before purchase finalization where applicable."
    },
    {
      title: "6. Escrow & Payouts",
      content: "Payouts are released only after user approval or system confirmation. Platform fees are deducted automatically."
    },
    {
      title: "7. Disputes",
      content: "Runners may respond to disputes but may not bypass resolution outcomes."
    },
    {
      title: "8. Ratings & Performance",
      content: "Ratings impact task access and account status."
    },
    {
      title: "9. Prohibited Conduct",
      content: "Runners may not:\n• Circumvent escrow\n• Misrepresent purchases\n• Perform unsafe or illegal actions"
    },
    {
      title: "10. Enforcement",
      content: "Sendrey may withhold payouts, suspend, or deactivate runners for violations."
    },
    {
      title: "11. Liability",
      content: "Runners are responsible for task execution risks."
    },
    {
      title: "12. Governing Law",
      content: "Governed by applicable local law."
    }
  ]
};